module.exports = __webpack_public_path__ + "static/img/FLORENCE_MAPLE.84798ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/FLORENCE_MAPLE.jpg
// module id = RvQb
// module chunks = 0